import { createSelector } from 'reselect'
import { DefaultTopicDetailsState } from '../reducers/topicDetails_reducer'
import * as SelectorUtils from './utils'

const getTopicByIdState = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return state.topics.byId[topicId]
}

const getTopicDetailsState = createSelector(
  [getTopicByIdState],
  (state) => {
    return (state || {}).details || DefaultTopicDetailsState
  }
)

const makeTopicDetailsSelector = () => {
  return createSelector(
    [getTopicDetailsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeTopicDetailsSelector
}
